"use strict";
/* eslint-disable */
// Adapted from:
// https://raw.githubusercontent.com/alexreardon/memoize-one/master/src/memoize-one.ts
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.memone = void 0;
var MemoStore = Symbol('MemoStore');
var isEqual = (function (a, b) {
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
});
var createMemoized = function (target, name) {
    return function () {
        var _a;
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        var store = (_a = this[MemoStore]) !== null && _a !== void 0 ? _a : (this[MemoStore] = new Map());
        if (store.has(name)) {
            var _b = __read(store.get(name), 2), lastArgs = _b[0], lastResult = _b[1];
            if (isEqual(newArgs, lastArgs)) {
                return lastResult;
            }
        }
        var newResult = target.apply(this, newArgs);
        store.set(name, [newArgs, newResult]);
        return newResult;
    };
};
var memone = function () {
    return function (_target, properyKey, descriptor) {
        descriptor.value = createMemoized(descriptor.value, properyKey);
        return descriptor;
    };
};
exports.memone = memone;
